const routes = [{
    path: '/index',
    name: 'index',
    meta: {
        title: '互联网医院',
        requiresAuth: true
    },
    component: resolve => require(['@/views/main'], resolve)
}, {
    path: '/login',
    name: 'login',
    meta: {
        title: '登陆',
    },
    component: resolve => require(['@/views/login'], resolve)
},
{
    path: '/medical/online_consult',
    name: 'medical_online_consult',
    meta: {
        title: '在线咨询',
        requiresAuth: true
    },
    props: route => {
        return {
            medicalRecord: JSON.parse(decodeURIComponent(route.query.medicalRecord))
        }
    },
    component: resolve => require(['@/views/medical/online_consult'], resolve)
}, {
    path: '/medical/doctor_filter',
    name: 'medical_doctor_filter',
    meta: {
        title: '医生筛选',
        requiresAuth: true
    },
    props: route => ({
        departmentId: route.query.departmentId,
        parentId: route.query.parentId
    }),
    component: resolve => require(['@/views/medical/doctor_filter'], resolve)
}, {
    path: '/medical/doctor_details',
    name: 'medical_doctor_details',
    meta: {
        title: '医生详情',
        requiresAuth: true
    },
    props: route => ({
        schedId: route.query.schedId
    }),
    component: resolve => require(['@/views/medical/doctor_details'], resolve)
}, {
    path: '/medical/inquiry_sheet',
    name: 'medical_inquiry_sheet',
    meta: {
        title: '问诊单填写',
        requiresAuth: true
    },
    props: route => ({
        schedId: route.query.schedId
    }),
    component: resolve => require(['@/views/medical/inquiry_sheet'], resolve)
}, {
    path: '/manage/health_record_manage',
    name: 'manage_health_record_manage',
    meta: {
        title: '健康档案管理',
        requiresAuth: true
    },
    component: resolve => require(['@/views/manage/health_record_manage'], resolve)
}, {
    path: '/manage/health_record',
    name: 'manage_health_record',
    meta: {
        title: '健康档案',
        requiresAuth: true
    },
    props: route => {
        return {
            id: route.query.id
        }
    },
    component: resolve => require(['@/views/manage/health_record'], resolve)
}, {
    path: '/payment/payment_order',
    name: 'payment_payment_order',
    meta: {
        title: '收银台',
        requiresAuth: true
    },
    props: route => ({
        transactionRecordId: route.query.transactionRecordId
    }),
    component: resolve => require(['@/views/payment/payment_order'], resolve)
}, {
    path: '/payment/payment_success',
    name: 'payment_payment_success',
    meta: {
        title: '支付结果',
        requiresAuth: true
    },
    props: route => ({
        transactionRecordId: route.query.transactionRecordId
    }),
    component: resolve => require(['@/views/payment/payment_success'], resolve)
}, {
    path: '/manage/address_list',
    name: 'manage_address_list',
    meta: {
        title: '地址管理',
        requiresAuth: true
    },
    component: resolve => require(['@/views/manage/address_list'], resolve)
}, {
    path: '/manage/address_manage',
    name: 'manage_address_manage',
    meta: {
        title: '我的地址',
        requiresAuth: true
    },
    props: route => ({
        id: route.query.id
    }),
    component: resolve => require(['@/views/manage/address_manage'], resolve)
}, {
    path: '/manage/medical_record',
    name: 'manage_medical_record',
    meta: {
        title: '我的咨询',
        requiresAuth: true
    },
    component: resolve => require(['@/views/manage/medical_record'], resolve)
}, {
    path: '/manage/medical_evaluation',
    name: 'manage_medical_evaluation',
    meta: {
        title: '咨询评价',
        requiresAuth: true
    },
    props: route => ({
        medicalRecordId: route.query.medicalRecordId
    }),
    component: resolve => require(['@/views/manage/medical_evaluation'], resolve)
}, {
    path: '/manage/case_history',
    name: 'manage_case_history',
    meta: {
        title: '电子病历',
        requiresAuth: true
    },
    props: route => ({
        medicalRecordId: route.query.medicalRecordId
    }),
    component: resolve => require(['@/views/manage/case_history'], resolve)
}, {
    path: '/manage/prescription_list',
    name: 'manage_prescription_list',
    meta: {
        title: '电子处方',
        requiresAuth: true
    },
    props: route => ({
        idCard: route.query.idCard
    }),
    component: resolve => require(['@/views/manage/prescription_list'], resolve)
}, {
    path: '/manage/prescription_details',
    name: 'manage_prescription_details',
    meta: {
        title: '处方详情',
        requiresAuth: true
    },
    props: route => ({
        prescriptionId: route.query.prescriptionId
    }),
    component: resolve => require(['@/views/manage/prescription_details'], resolve)
}, {
    path: '/manage/order_list',
    name: 'manage_order_list',
    meta: {
        title: '我的订单',
        requiresAuth: true
    },
    props: route => ({
        type: route.query.type
    }),
    component: resolve => require(['@/views/manage/order_list'], resolve)
}, {
    path: '/medical_card/organ_choose',
    name: 'medical_card_organ_choose',
    meta: {
        title: '选择医院',
        requiresAuth: true
    },
    component: resolve => require(['@/views/medical_card/organ_choose'], resolve)
}, {
    path: '/medical_card/card_list',
    name: 'medical_card_card_list',
    meta: {
        title: '就诊卡列表',
        requiresAuth: true
    },
    props: route => ({
        organId: route.query.organId
    }),
    component: resolve => require(['@/views/medical_card/card_list'], resolve)
}, {
    path: '/medical_card/card_type_choose',
    name: 'medical_card_card_type_choose',
    meta: {
        title: '添加就诊卡',
        requiresAuth: true
    },
    props: route => ({
        organId: route.query.organId
    }),
    component: resolve => require(['@/views/medical_card/card_type_choose'], resolve)
}, {
    path: '/medical_card/register_health_card',
    name: 'medical_card_register_health_card',
    meta: {
        title: '注册电子健康卡',
        requiresAuth: true
    },
    props: route => ({
        organId: route.query.organId
    }),
    component: resolve => require(['@/views/medical_card/register_health_card'], resolve)
}, {
    path: '/medical_card/manage_card',
    name: 'medical_card_manage_card',
    meta: {
        title: '就诊卡管理',
        requiresAuth: true
    },
    props: route => ({
        cardId: route.query.cardId
    }),
    component: resolve => require(['@/views/medical_card/manage_card'], resolve)
}, {
    path: '/medical_card/edit_health_card',
    name: 'medical_card_edit_health_card',
    meta: {
        title: '修改电子健康卡信息',
        requiresAuth: true
    },
    props: route => ({
        cardId: route.query.cardId
    }),
    component: resolve => require(['@/views/medical_card/edit_health_card'], resolve)
}, {
    path: '/manage/patient/patient_info',
    name: 'manage/patient/patient_info',
    meta: {
        title: '患者信息',
        requiresAuth: true
    },
    props: route => ({
        id: route.query.id
    }),
    component: resolve => require(['@/views/manage/patient/patient_info'], resolve)
}, {
    path: '/manage/patient/patient_elect',
    name: 'manage/patient/patient_elect',
    meta: {
        title: '我的电子病历',
        requiresAuth: true
    },
    props: route => ({
        idCard: route.query.idCard
    }),
    component: resolve => require(['@/views/manage/patient/patient_elect'], resolve)
}, {
    path: '/manage/patient/patient_lis',
    name: 'manage/patient/patient_lis',
    meta: {
        title: '检验报告',
        requiresAuth: true
    },
    props: route => ({
        id: route.query.id
    }),
    component: resolve => require(['@/views/manage/patient/patient_lis'], resolve)
}, {
    path: '/manage/patient/patient_pacs',
    name: 'manage/patient/patient_pacs',
    meta: {
        title: '检查报告',
        requiresAuth: true
    },
    props: route => ({
        id: route.query.id
    }),
    component: resolve => require(['@/views/manage/patient/patient_pacs'], resolve)
}, {
    path: '/manage/delivery',
    name: 'manage/delivery',
    meta: {
        title: '新增配送',
        requiresAuth: true
    },
    props: route => ({
        id: route.query.id
    }),
    component: resolve => require(['@/views/manage/delivery'], resolve)
}];



export default routes;